import React, { useState } from "react";
import FormInput from "../ContactForm/FormInput";
import FormSelector from "../ContactForm/FormSelector";
import { ToastContainer, toast } from "react-toastify";
import { TextField, Button, IconButton } from "@material-ui/core";
import { PostApi } from "../../middleware/postMiddleware"; // Ensure this is capable of handling file uploads
import { useHistory } from "react-router-dom";
import { Close as CloseIcon } from "@material-ui/icons";
import ReCAPTCHA from "react-google-recaptcha";
import { isTokenValid,getPayload } from "../../helpers/jwt";
import axios from 'axios';
import querystring from 'querystring';

function RequestForm({ bannerHeading, formTitle, formHeading }) {
  const history = useHistory();
  const [verified, setVerified] = useState(false);
  const [token, setToken] = useState(null);
  const [message, setMessage] = useState("");
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cityId, setCity] = useState('');
  

  function onCaptchaChange(value) {
    console.log("Captcha value:", value);
    setVerified(true);
    setToken(value);
  }

  const onChangeHandler = (e) => setMessage(e.target.value);

  const onFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const validFiles = selectedFiles.filter((file) =>
      file.size <= 5000000 && ["image/jpeg", "image/png", "application/pdf"].includes(file.type)
    );

    if (validFiles.length !== selectedFiles.length) {
      toast.error("Some files are invalid or too large and have been excluded.");
    }

    setFiles((prevFiles) => [...prevFiles, ...validFiles]);
  };

  const removeFile = (index) => setFiles(files.filter((_, i) => i !== index));

  const onSubmitHandler = async (event) => {
    event.preventDefault();
    setLoading(true);

    const first_name = event.target?.first_name?.value;
    const last_name = event.target?.last_name?.value;
    const company = event.target?.company?.value;
    const industry = event.target?.industry?.value;
    const email = event.target?.email?.value;
    const country = cityId;
    
    const city = "";
    const phone = "";
    const street_address = "";
    const suite = "";
    const state = "";
    const zip = "";
    const product = "";
    // const city = event.target?.city?.value;
    // const phone = event.target?.phone?.value;
    // const street_address = event.target?.street_address?.value;
    // const suite = event.target?.suite?.value;
    // const state = event.target?.state?.value;
    // const zip = event.target?.zip?.value;
    // const product = event.target?.product?.value;

    // console.log("first_name: : ", first_name);
    // console.log("last_name: ", last_name);
    // console.log("company: ", company);
    // console.log("email: ", email);
    // console.log("phone: ", phone);
    // console.log("street_address: ", street_address);
    // console.log("suite: ", suite);
    // console.log("city: ", city);
    // console.log("state: ", state);
    // console.log("zip: ", zip);
    // console.log("product: ", product);
    // console.log("message: ", message);
    // console.log("country: ",country);
    
    if (  !first_name || 
          !last_name || 
          !company || 
          !email ||
          !country || 
          !message 
         ) {
      toast.error("Please complete all required fields and verify the CAPTCHA.", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
      });
      setLoading(false);
      return;
    }

    let customerId = null;
    if(isTokenValid("auth_token")){
        customerId = getPayload("auth_token").id
    }

    const selectedOptions = [];

    if (event.target.productSample.checked) {
      selectedOptions.push(event.target.productSample.value);
    }

    if (event.target.bulkRequest.checked) {
      selectedOptions.push(event.target.bulkRequest.value);
    }
    const formData = new FormData();
    formData.append("first_name", first_name);
    formData.append("last_name", last_name);
    formData.append("company", company);
    formData.append("industry", industry);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("street_address", street_address);
    formData.append("suite", suite);
    formData.append("city", city);
    formData.append("state", state);
    formData.append("zip", zip);
    formData.append("country", country);
    formData.append("product", product);
    formData.append("description", message);
    formData.append("interestOptions", JSON.stringify(selectedOptions));

    if(customerId)
      formData.append("customerId", customerId);
 
    
    // Append files to the form data
    files.forEach(file => {
      formData.append("attachments", file);
    });

    try {

      // for (let pair of formData.entries()) {
      //   console.log(pair[0]+ ': ' + pair[1]);
      // }

      // const resStatus = await PostApi(`customer_complaint`, formData);

      const res = await axios.post(
          `${process.env.REACT_APP_API_URL}request_info`,
          formData, // Send the FormData directly
          {
              headers: {
                  'Content-Type': 'multipart/form-data' // Optional, Axios usually sets this automatically
              }
          }
      );

      if (res.status === 200) {
        toast.success("Thank you for your request. A Testfabrics representative will follow up with you within 1–2 business days.", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
        });
        // setTimeout(() => {
        //   history.push("/");
        // }, 2500);

        setMessage("");
        setFiles([]);
      } else {
        throw new Error("Failed to submit request.");
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong, please try again.", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer position="top-center" autoClose={3000} hideProgressBar theme="colored" />
      <section className="contact-form-wrapper section-padding pt-0">
        <div className="container">
          <div className="row">
            <div className="col-12 text-left mb-20">
              <h2>{bannerHeading}</h2>
              <span>{formTitle}</span>
              <h1>{formHeading}</h1>
            </div>

            <div className="col-12 col-lg-12">
              <div className="contact-form">
                <form className="row contact-form" onSubmit={onSubmitHandler}>
                  <FormInput type="text" labelFor="first_name" name="first_name" label="* First Name" placeholder="Enter your first name" id="first_name" />
                  <FormInput type="text" labelFor="last_name" name="last_name" label="* Last Name" placeholder="Enter your last name" id="last_name" />
                  <FormInput type="text" labelFor="company" name="company" label="* Company" placeholder="Enter company" id="company" />
                  <FormInput type="text" labelFor="industry" name="industry" label="Industry" placeholder="Enter industry" id="industry" />
                  <FormInput type="email" labelFor="email" name="email" label="* Email Address" placeholder="Enter Email Address" id="email2" />
                  <FormInput type="hidden" labelFor="phone" name="phone" label="Phone #" placeholder="Enter phone #" id="phone" />
                  <FormInput type="hidden" labelFor="street_address" name="street_address" label="* Street Adress" placeholder="Enter street address #" id="street_address" />
                  <FormInput type="hidden" labelFor="suite" name="suite" label="* Suite/Unit" placeholder="Enter suit/unit" id="suit" />
                  <FormInput type="hidden" labelFor="city" name="city" label="* City" placeholder="Enter city" id="city" />
                  <FormInput type="hidden" labelFor="state" name="state" label="* State" placeholder="Enter state" id="state" />
                  <FormInput type="hidden" labelFor="zip" name="zip" label="* Zip" placeholder="Enter zip" id="zip" />
                  <FormSelector label="* Country" name="shippingCountry" setCity={setCity}/>
                  <FormInput type="hidden" labelFor="product" name="product" label="* Product of Interest" placeholder="Enter product of interest" id="product" />

                  <TextField
                    // label= "* Comments"
                    placeholder="Please list the product(s), quantities, or specs you'd like quoted. If you're unsure, just describe your needs and we’ll guide you from there."
                    multiline
                    rows={2}
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={message}
                    onChange={onChangeHandler}
                  />

                  <div className="file-input-wrapper">
                    <label htmlFor="file-upload" className="theme-btn">Upload File(s)</label>
                    <input id="file-upload" type="file" onChange={onFileChange} multiple className="file-input" />
                  </div>

                  <div className="selected-files">
                    {files.map((file, index) => (
                      <div key={index} style={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
                        <span>{file.name}</span>
                        <IconButton onClick={() => removeFile(index)} size="small" aria-label="remove" style={{ marginLeft: "5px" }}>
                          <CloseIcon />
                        </IconButton>
                      </div>
                    ))}
                  </div>

                    
                  <div className="col-md-6 col-6 my-3">
                      <div className='row'>
                          <div>
                              <label htmlFor="productSample" style={{ width: "50%",cursor: "pointer" }}>I am interested in a product sample</label>
                              <input 
                                type="checkbox" 
                                id="productSample" 
                                name="productSample" 
                                value="I am interested in a product sample" 
                                style={{ width: "50%", }}
                                className="form-checkbox" 
                              />
                          </div>
                          <div>
                            <label 
                              htmlFor="bulkRequest" 
                              style={{ width: "50%", cursor: "pointer" }}>This is a bulk or institutional quote request</label>
                            <input 
                              type="checkbox" 
                              id="bulkRequest" 
                              name="bulkRequest" 
                              value="This is a bulk or institutional quote request" 
                              style={{ width: "50%" }} 
                              className="form-checkbox" 
                              />

                          </div>
                      </div>
                  </div>

                  <ReCAPTCHA sitekey={process.env.REACT_APP_RECAPTCHA_KEY} onChange={onCaptchaChange} />

                  <div style={{ display: "flex", justifyContent: "center", gap: "10px" }} className="col-md-12 col-12 text-center">
                    <Button type="submit" className="submit-btn" variant="contained" color="white" disabled={loading}>
                      {loading ? "Requesting..." : "REQUEST QUOTE"}
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .file-input-wrapper {
          position: relative;
          display: inline-block;
        }
        .file-input {
          opacity: 0;
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
      `}</style>
    </>
  );
}

export default RequestForm;
